/**
 * Hooks up controls for the header component
 */
export const woo_replaceButtonText = (): void => {
  const buttons = document.querySelectorAll('.add_to_cart_button') as unknown as HTMLElement[]

  if (!buttons || buttons.length < 1) {
    return
  }

  buttons.forEach(button => {
    if (button.innerText === 'Čtěte více' || button.innerText === 'ČTĚTE VÍCE') {
      button.innerHTML = 'REZERVOVAT JÍZDU'
    }
  })
}

/**
 * Hooks up controls for the header component
 */
export const woo_appendButtonsThankYouPage = (): void => {
  const sectionAppend = document.querySelector('.woocommerce-order-received.woocommerce-js .woocommerce-customer-details') as unknown as HTMLElement

  if (!sectionAppend) {
    return
  }

  sectionAppend.insertAdjacentHTML('beforeend', '<div class="specialThanksWrapper"><a href="https://www.nevimagroup.cz/akce/rezervace-hostice/" class=" button alt special" style="">Vybrat další stroj</a><a href="https://www.nevimagroup.cz/" class=" button alt special" style="">Domů</a></div>')
}

/**
 * Hooks up controls for the header component
 */
export const woo_changeMiniCart = (): void => {
  const miniCartButtons = document.querySelectorAll('.apbd-btn.apbd-btn-theme') as unknown as HTMLAnchorElement[]

  if (!miniCartButtons || miniCartButtons.length < 1) {
    return
  }

  miniCartButtons.forEach(button => {
    if (button.href === 'https://www.nevimagroup.cz/kosik/') {
      button.href = 'https://www.nevimagroup.cz/akce/rezervace-hostice/'
    }
  })
}

/**
 * Hooks up controls for the header component
 */
export const woo_changeMiniCartCounter = (): void => {
  const miniCartAmountWrapper = document.querySelector('.apbd-mca-item-counter ') as unknown as HTMLElement

  if (!miniCartAmountWrapper || miniCartAmountWrapper.textContent === null) {
    return
  }

  // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
  const miniCartAmount = parseInt(miniCartAmountWrapper.textContent.match(/\d+/)[0])

  let replacementString = 'kus'

  if (miniCartAmount > 5 || miniCartAmount === 0) {
    replacementString = 'kusů'
  }

  if (miniCartAmount > 1 && miniCartAmount < 5) {
    replacementString = 'kusy'
  }

  replacementString = `${miniCartAmount} ${replacementString}`

  miniCartAmountWrapper.textContent = replacementString
}
